import React, { useState, useEffect } from 'react';
import { useManifest } from '../../services/Firestore/Resources';
import Api from '../../services/Api/Api';
import { useLoading } from '../../services/LoadingContext/LoadingContext';
import { useErrorHandler } from '../../services/Utils/useErrorHandler';
import { createUseStyles } from 'react-jss';
import { ManifestDraft, ManifestSent } from '../../constants';

const useStyles = createUseStyles({
  menuTitle: {
    fontWeight: 'bold',
  },
  menuButton: {
    width: '65px',
    height: '25px',
  },
});

export const ManifestHoverMenu = ({ id }) => {
  const [manifest, loadingManifest] = useManifest(id);
  const classes = useStyles();
  const [sendDisabled, setSendDisabled] = useState(false);
  const [sendValidationError, setSendValidationError] = useState('');

  const errorHandler = useErrorHandler();
  const handleSend = useLoading(async (id) => {
    try {
      await Api.SendManifest({ id });
    } catch (e) {
      await errorHandler(e);
    }
  });

  const handleReceive = useLoading(async (id) => {
    try {
      await Api.ReceiveManifest({ id });
    } catch (e) {
      await errorHandler(e);
    }
  });

  const openInNewWindow = (id) => {
    window.open('manifests/' + id, '_blank');
  };

  useEffect(() => {
    const checkIfManifestReady = (manifest) => {
      if (manifest && manifest.items.length > 0) {
        for (const item of manifest.items) {
          if (item.value === 0) {
            setSendValidationError('This manifest has items without value, it cannot be sent');
            setSendDisabled(true);
            return;
          }
          if (item.description === '') {
            setSendValidationError(
              'This manifest has items without description, it cannot be sent',
            );
            setSendDisabled(true);
            return;
          }
        }
        setSendValidationError('Click to send');
        setSendDisabled(false);
        return;
      } else {
        setSendValidationError('This manifest has no items, and cannot be sent.');
        setSendDisabled(true);
      }
    };

    checkIfManifestReady(manifest);
  }, [manifest]);

  if (loadingManifest) {
    return <span>Loading menu</span>;
  }

  return (
    <>
      <span className={classes.menuTitle}>Menu:</span>
      {manifest && manifest.state === ManifestDraft && (
        <button
          className={classes.menuButton}
          onClick={() => handleSend(manifest.id)}
          title={sendValidationError}
          disabled={sendDisabled}
        >
          Send
        </button>
      )}
      {manifest && manifest.state === ManifestSent && (
        <button className={classes.menuButton} onClick={() => handleReceive(manifest.id)}>
          Receive
        </button>
      )}
      {manifest && (
        <button
          className={classes.menuButton}
          onClick={() => openInNewWindow(manifest.id)}
          title='Opens in a new tab'
        >
          Open
        </button>
      )}
    </>
  );
};
